import React from 'react'
import { Alert } from 'react-bootstrap'

class AlertDismissable extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      visible: true
    }
  }

  dismiss = () => this.setState({ visible: false })

  render() {
    if (!this.state.visible) return null
    if (!this.props.children) return null

    return (
      <Alert bsStyle={this.props.bsStyle} onDismiss={this.dismiss}>
        {this.props.children}
      </Alert>
    )
  }
}

export default AlertDismissable



// WEBPACK FOOTER //
// ./src/components/widgets/AlertDismissable.js